module.exports = __webpack_public_path__ + "img/diy1.87d5e5b5.png";